import React from "react";
import { CircleIcon, Flex, Text } from "@fluentui/react-northstar";
import { V360ReportData } from "view360Card/models";
import { ReportBox } from "../reportBox/ReportBox";
import { constants } from "shared/constants";
import { LabeledReportItem } from "../labeledReportItem/LabeledReportItem";
import { formatNumberOrEmtpy } from "utils/formattingUtils";

export interface ClaimRatioProps {
    report: V360ReportData;
    isMobileView: boolean;
}

export const ClaimRatio: React.FC<ClaimRatioProps> = (props) => {
    const getSeriesWsb = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.percentage && s.code === "WSB"),
        []
    );
    const getSeriesMsb = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.percentage && s.code === "MWZB"),
        []
    );
    const getSeriesStatus = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.string && s.code === "STATUS"),
        []
    );

    const getContent = () => {
        return (
            <Flex gap="gap.large" fill styles={{ paddingTop: "10px" }}>
                {getSeriesStatus && getSeriesStatus.dataset.length > 0 && (
                    <LabeledReportItem
                        label={getSeriesStatus.name}
                        tooltip={getSeriesStatus.tooltip}
                        content={
                            <CircleIcon size="large" style={{ color: getSeriesStatus.dataset[0], paddingTop: "2px" }} />
                        }
                    />
                )}
                {getSeriesWsb && getSeriesWsb.dataset.length > 0 && (
                    <LabeledReportItem
                        label={getSeriesWsb.name}
                        tooltip={getSeriesWsb.tooltip}
                        content={
                            <Text weight="bold" size="large">
                                {formatNumberOrEmtpy(getSeriesWsb.dataset[0], true)}
                            </Text>
                        }
                    />
                )}
                {getSeriesMsb && getSeriesMsb.dataset.length > 0 && (
                    <LabeledReportItem
                        label={getSeriesMsb.name}
                        tooltip={getSeriesMsb.tooltip}
                        content={
                            <Text weight="bold" size="large">
                                {formatNumberOrEmtpy(getSeriesMsb.dataset[0], true)}
                            </Text>
                        }
                    />
                )}
            </Flex>
        );
    };

    return <ReportBox noGap title={props.report.name || ""} content={getContent()} />;
};
